import { cookieNames, getCookieValue } from "utility/CookieHelper";
import { isUserLoggedIn } from "utility/LoginHelper";

export const useIsSessionExpired = () => {
  const sessionExpired = getCookieValue(cookieNames.EXPIRED);
  return isUserLoggedIn() && sessionExpired === "true";
};
